export default __webpack_public_path__ + "static/media/sts.f8990f8b.svg";